import * as React from 'react';
import { Route, Switch } from 'react-router';

import HomeDashboard from './Page/Opportunity';
import Opportunities from '../src/Components/Opportunities/Opportunities';
import AddOpportunities from '../src/Components/Opportunities/AddOpportunities';
import OpportunityChart from '../src/Components/Opportunities/OpportunityChart';
import OfficeLocationDashboard from '../src/Components/OfficeLocation/OfficeLocationDashboard';
import ProjectScoreCardDashboard from '../src/Components/ProjectScoreCard/ProjectScoreCardDashboard'
import AddLookupRequestDashboard from './Components/Lookup/LookupDashboard'
import LookupRequestDashboard from './Components/LookupRequest/LookupRequestDashboard'
import ChartColorDashboard from './Components/ChartColor/ChartColorDashboard'
import Dashboard from './Page/Dashboard';
import AddProjectScoreCardVersion from './Components/ProjectScoreCard/AddProjectScoreCardVersion';

export const Routes = () => <Switch>
    <Route exact path='/' component={HomeDashboard} />
    <Route exact path='/dashboard' component={Dashboard} />
    <Route exact path='/opportunity' component={HomeDashboard} />
    <Route exact path='/add-opportunity' component={AddOpportunities} />
    <Route exact path='/edit-opportunity/:OpportunityId' component={AddOpportunities} />
    <Route exact path='/Office-Location' component={OfficeLocationDashboard} />
    <Route exact path='/Lookup' component={AddLookupRequestDashboard} />
    <Route exact path='/Lookup-Request' component={LookupRequestDashboard} />
    <Route exact path='/Project-Score-Card' component={ProjectScoreCardDashboard} />
    <Route exact path='/add-score-card-version' component={AddProjectScoreCardVersion} />      
    <Route exact path='/edit-score-card-version/:ScoreCardId' component={AddProjectScoreCardVersion} />    
    <Route exact path='/Chart-color' component={ChartColorDashboard} />
    <Route exact path='/opportunitychart' component={OpportunityChart} />

</Switch>
